/**
 * Extracts an MPX token from a provided authToken.
 */

const extractMpxTokenFromAuthToken = (authToken: string): string => {
    const userDetails = JSON.parse(window.atob(authToken.split('.')[1]));

    return userDetails.mpx;
};

export default extractMpxTokenFromAuthToken;